
import React from 'react';
import { toast } from 'sonner';
import { type ErrorLog } from '@/utils/logger';

interface ErrorLogActionsProps {
  errors: ErrorLog[];
}

const ErrorLogActions: React.FC<ErrorLogActionsProps> = ({ errors }) => {
  const handleSendAllErrorReports = () => {
    // In a production app, this would send errors to an error tracking service
    const errorData = errors.map(error => ({
      message: error.error.message,
      stack: error.error.stack,
      component: error.component,
      context: error.context,
      timestamp: error.timestamp,
      userReported: error.userReported
    }));
    
    console.log('Sending error reports:', errorData);
    
    // Simulate sending to error tracking service
    setTimeout(() => {
      toast.success(`${errors.length} error reports sent to the development team`);
    }, 1000);
  };
  
  return (
    <div className="hidden">
      {/* This component now returns a React node instead of an object */}
    </div>
  );
};

// Export the handleSendAllErrorReports function separately
export const useErrorLogActions = (errors: ErrorLog[]) => {
  const actionHandler = React.useMemo(() => {
    const handleSendAllErrorReports = () => {
      // In a production app, this would send errors to an error tracking service
      const errorData = errors.map(error => ({
        message: error.error.message,
        stack: error.error.stack,
        component: error.component,
        context: error.context,
        timestamp: error.timestamp,
        userReported: error.userReported
      }));
      
      console.log('Sending error reports:', errorData);
      
      // Simulate sending to error tracking service
      setTimeout(() => {
        toast.success(`${errors.length} error reports sent to the development team`);
      }, 1000);
    };
    
    return { handleSendAllErrorReports };
  }, [errors]);
  
  return actionHandler;
};

export default ErrorLogActions;
